import { Controller } from "@hotwired/stimulus";

// Renders a running mm'ss" clock counting up from the game's kickoff time,
// so spectators watching /ao-vivo see the match clock ticking in real time
// without needing to refresh the page. The score/status itself is kept in
// sync separately via Turbo Streams (see Game#broadcast_live_section) —
// this controller only handles the second-by-second clock display, which
// has to run locally since broadcasting every second would be wasteful.
export default class extends Controller {
  // pausedAt: timestamp (ms) the referee paused at, or 0 when currently
  // running. pausedSeconds: total time already spent paused before now,
  // accumulated by Game#resume! each time play restarts. Together they let
  // the clock freeze exactly where it stopped and pick back up correctly —
  // see Game#pause!/#resume! for the server-side half of this.
  static values = { startedAt: Number, pausedAt: Number, pausedSeconds: Number };

  connect() {
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer);
  }

  tick() {
    const now = this.pausedAtValue > 0 ? this.pausedAtValue : Date.now();
    const pausedMs = (this.pausedSecondsValue || 0) * 1000;
    const elapsedMs = now - this.startedAtValue - pausedMs;
    const totalSeconds = Math.max(0, Math.floor(elapsedMs / 1000));
    const minutes = Math.floor(totalSeconds / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (totalSeconds % 60).toString().padStart(2, "0");
    this.element.textContent = `${minutes}'${seconds}"`;
  }
}
